import SlideFrame from './SlideFrame';
import type { TreeNodeType } from '../../i18n/types';

interface TreeNode { txt: string; type: TreeNodeType; note?: string }
interface LegendItem { type: TreeNodeType; label: string }

interface Props {
  title: string; sub: string;
  tree: TreeNode[];
  legend?: LegendItem[];
}

const TYPE_CLASS: Record<TreeNodeType, string> = {
  always: 'tree-row--always',
  ondemand: 'tree-row--ondemand',
  manual: 'tree-row--manual',
  muted: 'tree-row--muted',
  root: 'tree-row--root',
  hooks: 'tree-row--hooks',
  ide: 'tree-row--ide',
};

const TYPE_DOT: Record<TreeNodeType, string> = {
  always: '#2D9A5F',
  ondemand: '#185FA5',
  manual: '#BA7517',
  muted: '#999',
  root: '#333',
  hooks: '#7B3FA0',
  ide: '#0B6E8A',
};

export default function FileTree({ title, sub, tree, legend }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      {legend && (
        <div className="tree-legend">
          {legend.map((l, i) => (
            <span key={i} className="tree-legend-item">
              <span className="tree-legend-dot" style={{ background: TYPE_DOT[l.type] }} />
              {l.label}
            </span>
          ))}
        </div>
      )}
      <div className="tree">
        {tree.map((node, i) => (
          <div key={i} className={`tree-row ${TYPE_CLASS[node.type]}`}>
            <span className="tree-txt">{node.txt}</span>
            {node.note && <span className="tree-note">{node.note}</span>}
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
